export default __webpack_public_path__ + "static/media/left_blur500.aeb02574.png";